import { render } from "./ListeCategProduit.vue?vue&type=template&id=e82fd10c&ts=true"
import script from "./ListeCategProduit.vue?vue&type=script&lang=ts"
export * from "./ListeCategProduit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__